import React, {useState}  from 'react'
import {localestr} from '../utils'


function SeveralForm({Text,caption,data,setModal,action,id}){
    const [val, setVal] = useState(data.map(el=>el.value)||[]) 
    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
        const elmnt=document.getElementById('modalWnd'+id)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
    
    function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
    }

    function setCheck(value,checked) {
        let newval=Array.from(val)
        if(checked){
            if(!newval.includes(value)) {newval.push(value);setVal(newval)}
        } else {
            if(newval.includes(value)) setVal(newval.filter(el=>el!==value))
        }
    }

    const cont=data.map((el,idx)=>{
        return <label key={idx} style={{margin:'8px 4px'}}><input type='checkbox' checked={val.includes(el.value)} onChange={e=>setCheck(el.value,e.target.checked)} /><div style={{display:'inline-block',userSelect:'none'}}>{el.caption}</div></label>
    })

    return(
        <div className='modal'>
            <div id={'modalWnd'+id} className='window'>
                <div className='no-print' onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{caption||localestr('Повідомлення')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
                <div className='content'>
                <div style={{margin:'0',display:'flex',justifyContent:'center',whiteSpace:'pre-wrap',fontWeight:'bold'}}>
                    {Text}
                </div>
                <div style={{margin:'0',display:'flex',flexDirection:'column',justifyContent:'center',whiteSpace:'pre-wrap'}}>
                    {cont}
                </div>
                <div style={{margin:'4px 0 0 0',display:'flex',justifyContent:'center'}}>
                    <div style={{width:'100px',display:'inline-block',verticalAlign:'bottom'}} className={'ord_button2 toolBarItem toolBarItem2'} onClick={()=>{setModal('');action(val)}}><div>OK</div></div>
                    <div style={{width:'100px',height:'36px',display:'inline-block',verticalAlign:'bottom',borderRadius:'22px'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{textAlign:'center',display:'block',lineHeight:'36px'}}>{localestr('Скасувати')}</div></div>
                </div></div>
            </div>
        </div>
    )
}

export default SeveralForm